import React from 'react';
import { CircleUserRound, ClipboardList, MessagesSquare, UserRound } from 'lucide-react';
import { NavLink, useLocation } from 'react-router';

import {
  HamburgerButton,
  MobileDrawer,
  StudentMobileNav,
} from 'components/MobileDrawer';
import { ChatUnreadBadge } from 'components/ChatUnreadBadge/ChatUnreadBadge';
import { NotificationBell } from 'components/NotificationBell/NotificationBell';
import { useIsMobileLayout } from 'hooks/useMediaQuery';
import logo from 'assets/images/logotype/Logo_Ychenick_Orange.svg';

import { CabinetHeaderNav, type CabinetHeaderNavItem } from './CabinetHeaderNav';
import styles from './HeaderStudent.module.scss';

const STUDENT_NAV: CabinetHeaderNavItem[] = [
  { to: '/profile/tasks', label: 'Мои задачи', Icon: ClipboardList },
  { to: '/profile', label: 'Мой профиль', Icon: UserRound, end: true },
  { to: '/profile/chats', label: 'Мои чаты', Icon: MessagesSquare, badge: <ChatUnreadBadge accent='student' /> },
];

const HeaderLogo = () => (
  <div className={styles['header-logo']}>
    <NavLink to='/profile/tasks'>
      <img src={logo} alt='MyTeacher.pro' />
    </NavLink>
    <div className={styles['header-logo__content']}>
      <h4>MYTEACHER</h4>
      <span>PRO</span>
    </div>
  </div>
);

/* Figma 18:2645 / 66:2485: справа колокол и профиль, непрочитанные чаты - бейдж на пункте пилюли.
   Figma 18:2905 (360): логотип слева, меню справа; чаты и профиль в выдвижном меню, колокол оставлен. */
const HeaderContent = ({ menuButton }: { menuButton?: React.ReactNode }) => (
  <div className={styles['header-content']}>
    <NotificationBell accent='student' />
    {menuButton ?? (
      <NavLink to='/profile' aria-label='Профиль' className={styles.profileLink}>
        <CircleUserRound size={28} strokeWidth={2} aria-hidden className={styles.profileIcon} />
      </NavLink>
    )}
  </div>
);

export const HeaderStudent = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const isMobile = useIsMobileLayout();
  const location = useLocation();

  React.useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  const closeDrawer = () => setDrawerOpen(false);

  return (
    <header className={styles.header}>
      <div className={styles['header-wrapper-content']}>
        <div className={styles['header-leading']}>
          <HeaderLogo />
        </div>
        {isMobile ? null : <CabinetHeaderNav items={STUDENT_NAV} />}
        <HeaderContent
          menuButton={
            isMobile ? (
              <HamburgerButton open={drawerOpen} onClick={() => setDrawerOpen((prev) => !prev)} />
            ) : undefined
          }
        />
      </div>

      {isMobile && (
        <MobileDrawer
          open={drawerOpen}
          onClose={closeDrawer}
          title='Меню ученика'
          accent='student'
        >
          <StudentMobileNav onNavigate={closeDrawer} />
        </MobileDrawer>
      )}
    </header>
  );
};
